import "./index.css";
import Button from "@mui/material/Button";
import AlertDialogForm from "./il2_approval_dialog";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import axios from "axios";
import ReassignAlertDialogForm from "./reassign_alertdialog";
import ReassignIcon from "@mui/icons-material/Autorenew";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";

import {
  VAVE,
  DOWNLOAD2B2FILE,
  GETIL2BYEMPID,
  GET2B2DATA,
  DOWNLOADUPLOADEDUSERFILE,
} from "../../AppConstant";
import DownloadIcon from "@mui/icons-material/Download";
import { Pagination, Stack } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";

import loadergif from "../../../assets/images/BG-switch loader_2.gif";
import { sourcingEmpIds } from "../switch_on_userlist";

function SwitchOnIL2List({ role, setIsLoading }) {
  const [refreshApi, setRefreshApi] = useState(false);
  const [allIdeas, setAllIdeas] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [ideaListByEmpId, setIdeaListByEmpId] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [viewMoreOpenDialog, setViewMoreOpenDialog] = useState(false);
  const [reAssignOpenDialog, setreAssignOpenDialog] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(ideaListByEmpId.length / itemsPerPage);
  const [selectedIdea, setSelectedIdea] = useState(null);
  const [createuri, setCreateuri] = useState("");
  const navigate = useNavigate();
  const currentEmpId = localStorage.getItem("empid");
  const [isloading, setIsloading] = useState(false);

  const isIdeaUpdatedToday = (idea) => {
    if (!idea?.url_2b2_created_timestamp) return false;

    const updatedDate = new Date(idea.url_2b2_created_timestamp)
      .toISOString()
      .split("T")[0];

    return updatedDate === "2025-11-20";
  };

  const handleButtonClick = (filter) => {
    setSelectedFilter(filter);
    setCurrentPage(1);
    handleFilter(filter);
  };
  const handleViewMore = (idea) => {
    setSelectedIdea(idea);
    setViewMoreOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRequest(null);
  };
  const handleViewMoreCloseDialog = () => {
    setViewMoreOpenDialog(false);
    setSelectedIdea(null);
  };

  const handleReassignCloseDialog = () => {
    setreAssignOpenDialog(false);
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "accepted":
        return "green";
      case "rejected":
        return "red";
      case "inprogress":
        return "orange";
      default:
        return "gray";
    }
  };

  useEffect(() => {
    fetchIdeas();
  }, []);

  useEffect(() => {
    if (!refreshApi) return;
    fetchIdeas();
    handleFilter("inprogress");
    setOpenDialog(false);
    setreAssignOpenDialog(false);
    setRefreshApi(false);
  }, [refreshApi]);
  // useEffect(() => {
  //   handleFilter("All");
  // }, []);
  const fetchIdeas = async () => {
    const currentEmpId = localStorage.getItem("empid") || "";
    // const url = allowedEmpIdsForIL2.includes(currentEmpId)
    //   ? GETIL2BYEMPID
    //   : GETIL2BYEMPID;

    try {
      const response = await axios.get(VAVE + GETIL2BYEMPID, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      const ideas = response.data.data || [];
      setAllIdeas(ideas);
      if (!refreshApi) {
        handleFilter("All", ideas); // Initial filter
      } else {
        handleFilter("inprogress", ideas);
      }
      // handleFilter("All", ideas); // Initial filter
    } catch (error) {
      console.error("Error fetching ideas:", error);
    }
  };

  const handleFilter = (filter, data = allIdeas) => {
    const currentEmpId = localStorage.getItem("empid") || "";

    let filtered = [];

    if (filter === "All") {
      filtered = data;
    } else {
      filtered = data.filter((idea) => {
        if (idea.il2_costing_empid === currentEmpId) {
          return (
            idea.il2_costing_status?.toLowerCase() === filter.toLowerCase()
          );
        } else if (idea.il2_it_empid === currentEmpId) {
          return idea.il2_it_status?.toLowerCase() === filter.toLowerCase();
        } else if (idea.il2_pd_empid === currentEmpId) {
          return idea.il2_pd_status?.toLowerCase() === filter.toLowerCase();
        } else if (idea.il2_marketing_empid === currentEmpId) {
          return (
            idea.il2_marketing_status?.toLowerCase() === filter.toLowerCase()
          );
        }
        // else if (idea.il2_manuf_busbody_empid === currentEmpId) {
        //   return (
        //     idea.il2_manuf_busbody_status?.toLowerCase() ===
        //     filter.toLowerCase()
        //   );
        // }
        else if (idea.il2_quality_empid === currentEmpId) {
          return (
            idea.il2_quality_status?.toLowerCase() === filter.toLowerCase()
          );
        } else if (idea.il2_manuf_empid === currentEmpId) {
          return idea.il2_manuf_status?.toLowerCase() === filter.toLowerCase();
        }

        // else if (idea.il2_manuf_ennore_empid === currentEmpId) {
        //   return (
        //     idea.il2_manuf_ennore_status?.toLowerCase() === filter.toLowerCase()
        //   );
        // }
        else if (idea.il2_sourcing_empid === currentEmpId) {
          return (
            idea.il2_sourcing_status?.toLowerCase() === filter.toLowerCase()
          );
        }
        return false;
      });
    }

    setIdeaListByEmpId(filtered);
  };

  // const downloadfiles = (request) => {
  //   if (!createuri) {
  //     console.error("No download URL available");
  //     return;
  //   }

  //   const link = document.createElement("a");
  //   link.href = createuri;
  //   link.setAttribute("download", `Idea_${request.idea_unique_id}_Report.xlsx`);
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);

  //   // Clean up the object URL
  //   URL.revokeObjectURL(createuri);
  //   setCreateuri(null); // Reset the URL
  // };

  // const downloadApi = (request) => {
  //   setIsloading(true);
  //   axios({
  //     method: "post",
  //     url: VAVE + DOWNLOAD2B2FILE,
  //     headers: { "Content-Type": "application/x-www-form-urlencoded" },
  //     data: { idea_id: request.ideaid },
  //     responseType: "blob",
  //   })
  //     .then((response) => {
  //       if (response.data.size === 14) {
  //         alert("No Data Available");
  //         setIsloading(false);
  //         return;
  //       }

  //       const url = URL.createObjectURL(response.data);
  //       console.log(url);
  //       setCreateuri(url);
  //       setIsloading(false);

  //       // Auto-download after setting the URL
  //       downloadfiles(request);
  //     })
  //     .catch((error) => {
  //       console.error("Download failed:", error);
  //       setIsloading(false);
  //     });
  // };

  const downloadApi = (request) => {
    setIsloading(true);
    axios({
      method: "post",
      url: VAVE + DOWNLOAD2B2FILE,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: { idea_id: request.id_x },
      responseType: "blob",
    })
      .then((response) => {
        if (response.data.size === 14) {
          alert("No Data Available");
          setIsloading(false);
          return;
        }

        // Create blob and download immediately
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Idea_${request.idea_unique_id}_Report.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Clean up
        URL.revokeObjectURL(url);
        setIsloading(false);
      })
      .catch((error) => {
        console.error("Download failed:", error);
        setIsloading(false);
      });
  };

  const downloadUploadedUserDocApi = (request) => {
    setIsloading(true);
    axios({
      method: "post",
      url: VAVE + DOWNLOADUPLOADEDUSERFILE,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: { idea_id: request.id_x },
      responseType: "blob",
    })
      .then((response) => {
        if (response.data.size === 14) {
          alert("No Data Available");
          setIsloading(false);
          return;
        }

        const contentType =
          response.headers["content-type"] || "application/pdf";
        const disposition = response.headers["content-disposition"];
        let filename = `Idea_${request.idea_unique_id}_User_Document.pdf`;

        const blob = new Blob([response.data], { type: contentType });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Clean up
        URL.revokeObjectURL(url);
        setIsloading(false);
      })
      .catch((error) => {
        console.error("Download failed:", error);
        setIsloading(false);
      });
  };

  // const filteredIdeas = ideaListByEmpId.filter((item) => {
  //   const query = searchQuery.toLowerCase();
  //   const matchesSearch = Object.values(item).some((value) =>
  //     String(value).toLowerCase().includes(query)
  //   );

  //   return matchesSearch;
  // });

const filteredIdeas = Array.isArray(ideaListByEmpId)
  ? ideaListByEmpId.filter((item) => {
      const query = searchQuery.toLowerCase();
      return Object.values(item).some((value) =>
        String(value).toLowerCase().includes(query)
      );
    })
  : [];

  const paginatedIdeas = filteredIdeas.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="container mt-2">
      {isloading ? (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div className="loadergif">
            <img src={loadergif} alt="Loading..." />
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="d-flex flex-row align-items-center gap-3 flex-wrap pb-3 pt-4">
        <div className="d-flex align-items-center">
          <label className="me-2">Search</label>
          <input
            type="text"
            className="form-control"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
              setCurrentPage(1);
            }}
            style={{ width: "200px" }}
          />
        </div>
        <div className="d-flex gap-2">
          <Button
            variant="contained"
            color={selectedFilter === "All" ? "success" : "primary"}
            onClick={() => handleButtonClick("All")}
          >
            All
          </Button>
          <Button
            variant="contained"
            color={selectedFilter === "inprogress" ? "success" : "primary"}
            onClick={() => handleButtonClick("inprogress")}
          >
            Pending
          </Button>

          <Button
            variant="contained"
            color={selectedFilter === "accepted" ? "success" : "primary"}
            onClick={() => handleButtonClick("accepted")}
          >
            Accepted
          </Button>
          <Button
            variant="contained"
            color={selectedFilter === "rejected" ? "success" : "primary"}
            onClick={() => handleButtonClick("rejected")}
          >
            Rejected
          </Button>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-bordered table-striped custom-table">
          <thead className="thead-dark">
            <tr>
              <th>SW Id</th>

              <th>Proposed Idea</th>
              <th>Part No</th>
              <th>Savings</th>
              {/* <th>Aggregate</th> */}
              <th>Download Excel</th>
              <th>Variant</th>
              <th>View More</th>
            </tr>
          </thead>
          <tbody>
            {paginatedIdeas.length === 0 ? (
              <tr>
                <td colSpan="8" className="text-center py-4">
                  No ideas found
                </td>
              </tr>
            ) : (
              paginatedIdeas.map((req, index) => (
                <tr key={req.id}>
                  <td>{req.idea_unique_id}</td>
                  {/* {selectedFilter === "All" && (
                  <td style={{ cursor: "pointer" }}>
                    <span
                      title={ req.il1_pd_status}
                      style={{
                        display: "inline-block",
                        width: "18px",
                        height: "18px",
                        borderRadius: "50%",
                        backgroundColor: getStatusColor(sourcingEmpIds.includes(currentEmpId) ?req.il1_sourcing_status :req.il1_pd_status),
                        marginRight: "8px",
                      }}
                    ></span>
                  </td>
                )} */}
                  {/* {selectedFilter === "inprogress" &&
                   (
                    <td
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setreAssignOpenDialog(true);
                        setSelectedRequest(req);
                      }}
                    >
                      <ReassignIcon />
                    </td>
                  )} */}
                  {selectedFilter !== "inprogress" ? (
                    <td>
                      {" "}
                      <Tooltip title={req.proposed_idea_x || ""} arrow>
                        {/* <td> */}
                        {req.proposed_idea_x?.slice(0, 15)}
                        {req.proposed_idea_x?.length > 15 ? "..." : ""}
                        {/* </td> */}
                      </Tooltip>
                    </td>
                  ) : (
                    <td
                      style={{
                        cursor: "pointer",
                        textDecoration: "underline",
                        color: "blue",
                      }}
                      onClick={() => {
                        setSelectedRequest(req);
                        setOpenDialog(true);
                      }}
                    >
                      <Tooltip title={req.proposed_idea_x || ""} arrow>
                        {/* <td> */}
                        {req.proposed_idea_x?.slice(0, 15)}
                        {req.proposed_idea_x?.length > 15 ? "..." : ""}
                        {/* </td> */}
                      </Tooltip>
                    </td>
                  )}

                  <td>{req.partno}</td>

                  <Tooltip title={req.benefit || ""} arrow>
                    <td>
                      {req.benefit?.slice(0, 15)}
                      {req.benefit?.length > 15 ? "..." : ""}
                    </td>
                  </Tooltip>
                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() => downloadApi(req)}
                  >
                    <DownloadIcon />
                  </td>
                  {/* <td>{req.idea_effective}</td> */}

                  <td>{req.varient}</td>

                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() => handleViewMore(req)}
                  >
                    <FormatListBulletedIcon />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Request Details</DialogTitle>
        <DialogContent dividers>
          <AlertDialogForm
            request={selectedRequest}
            setRefreshApi={setRefreshApi}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={reAssignOpenDialog}
        onClose={handleReassignCloseDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>ReAssign</DialogTitle>
        <DialogContent dividers>
          <ReassignAlertDialogForm
            request={selectedRequest}
            setRefreshApi={setRefreshApi}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleReassignCloseDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog for View More */}
      <Dialog
        open={viewMoreOpenDialog}
        onClose={handleViewMoreCloseDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Idea Details</DialogTitle>
        <DialogContent>
          {selectedIdea && (
            <Grid container spacing={2}>
              {/* Left Column */}
              <Grid item xs={10} sm={6}>
                  <Typography variant="body1">
                                  <strong>Employee Id:</strong> {selectedIdea.emp_id}
                                </Typography>
                                <Typography variant="body1">
                                  <strong>Employee Email:</strong> {selectedIdea.emp_email}
                                </Typography>
                <Typography variant="body1">
                  <strong>SW Id:</strong> {selectedIdea.idea_unique_id}
                </Typography>
                {/* <Typography variant="body1">
                  <strong>Status:</strong>{" "}
                  <span style={{ color: getStatusColor(selectedIdea.status) }}>
                    {selectedIdea.status}
                  </span>
                </Typography> */}
                <Typography variant="body1">
                  <strong>Idea Category:</strong> {selectedIdea.idea_category_x}
                </Typography>
                <Typography variant="body1">
                  <strong>Part No:</strong> {selectedIdea.partno}
                </Typography>
                <Typography variant="body1">
                  <strong>Description:</strong> {selectedIdea.part_description}
                </Typography>
                <Typography variant="body1">
                  <strong>Proposed Idea:</strong> {selectedIdea.proposed_idea_x}
                </Typography>
                <Typography variant="body1">
                  <strong>Current Condition:</strong>{" "}
                  {selectedIdea.current_condition}
                </Typography>
                {sourcingEmpIds.includes(currentEmpId) ? (
                  <Typography variant="body1">
                    <strong>Comments:</strong>{" "}
                    {selectedIdea.il1_sourcing_comment}
                  </Typography>
                ) : (
                  <Typography variant="body1">
                    <strong>Comments:</strong> {selectedIdea.il1_pd_comment}
                  </Typography>
                )}
              </Grid>
              {/* Right Column */}
              <Grid item xs={12} sm={6}>
                <Typography variant="body1">
                  <strong>Savings:</strong> {selectedIdea.benefit}
                </Typography>
                <Typography variant="body1">
                  <strong>Aggregate:</strong> {selectedIdea.idea_effective}
                </Typography>
                <Typography variant="body1">
                  <strong>Model:</strong> {selectedIdea.model}
                </Typography>
                <Typography variant="body1">
                  <strong>Variant:</strong> {selectedIdea.varient}
                </Typography>

                <Typography variant="body1">
                  <strong>Sub Variant:</strong> {selectedIdea.subvarient}
                </Typography>
                <Typography variant="body1">
                  <strong>Domain:</strong> {selectedIdea.domain}
                </Typography>
                <Typography variant="body1">
                  <strong>Function:</strong> {selectedIdea.function}
                </Typography>
                <Typography variant="body1">
                  <strong>Location:</strong> {selectedIdea.location}
                </Typography>

                <Typography variant="body1">
                  <strong>Document:</strong>{" "}
                  {selectedIdea.filepath ? (
                    isIdeaUpdatedToday(selectedIdea) ? (
                      <a
                        href={selectedIdea.filepath}
                        target="_blank"
                        rel="noreferrer"
                      >
                        View File
                      </a>
                    ) : (
                      <button
                        style={{
                          cursor: "pointer",
                          color: "blue",
                          border: "transparent",
                          background: "transparent",
                        }}
                        onClick={() => downloadUploadedUserDocApi(selectedIdea)}
                      >
                        Download File
                      </button>
                    )
                  ) : (
                    "No File"
                  )}
                </Typography>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleViewMoreCloseDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Stack alignItems="center" marginTop={1} color="white">
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={(event, value) => setCurrentPage(value)}
          color="primary"
          variant="outlined"
          shape="circular"
          sx={{
            "& .MuiPaginationItem-root": {
              color: "black",
              borderColor: "black",
              backgroundColor: "white",
            },
            "& .Mui-selected": {
              backgroundColor: "green",
              color: "white",
            },
          }}
        />
      </Stack>
    </div>
  );
}

export default SwitchOnIL2List;
